import { useState, useEffect } from 'react';

export const useIncrementalRendering = (
  totalNumber: number,
  startingValue: number,
  interval: number,
  incrementBy = startingValue,
) => {
  const [toRender, setToRender] = useState(startingValue);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setToRender((v) => v + incrementBy);
    }, interval);
    if (toRender >= totalNumber) {
      clearInterval(intervalId);
    }

    return () => clearInterval(intervalId);
  }, [totalNumber, toRender, interval, incrementBy, startingValue]);

  return toRender;
};
